import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Button} from "react-bootstrap";
import React from "react";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

function WarningDialog(props) {

    return (
        <Dialog
            open={props.openDialog}
            onClose={props.handleCloseDialog}
            aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title" style={{border:'1px solid #dee2e6' , color: 'sandybrown'}}>
                <div>
                    <p style={{ verticalAlign: 'middle', float: 'left',fontSize: 30,margin: 0,paddingTop: 8}}>{'Emin Misiniz?'}</p>
                    <HelpOutlineOutlinedIcon style={{fontSize: 60, float: 'right'}}/>
                </div>
            </DialogTitle>
            <DialogContent style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <DialogContentText>
                    {props.dialogContentText}
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{borderTop: '1px solid #dee2e6'}}>
                <Button onClick={props.handleAcceptDialog} variant="primary">
                    Evet
                </Button>
                <Button onClick={props.handleCloseDialog} variant="danger" autoFocus>
                    Hayır
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default WarningDialog;